import { PaperlesBannerComponent } from '../dashboard/loggedin-content/my-insurance/paperles-banner/paperles-banner.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewChildren, QueryList, HostListener, ChangeDetectorRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CustomerBannerService } from '@services/banner/customer-banner/customer-banner.service';
import { CustomerBannerData } from '@models/customer-banner';
import { SwiperContainer } from 'swiper/element';
import { PaperlessService } from '../../_services/_iam/paperless.service';
import { CustomerBannerComponent } from '@loggedin-content/my-insurance/custom-banner/customer-banner.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomerBannerComponent, PaperlesBannerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-carousel-banner',
  templateUrl: './carousel-banner.component.html',
  styleUrls: ['./carousel-banner.component.css'],
})
export class CarouselBannerComponent implements OnInit, AfterViewInit {
  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;
  @ViewChildren(CustomerBannerComponent) customerBanners!: QueryList<CustomerBannerComponent>;

  banners: CustomerBannerData[] = [];
  isAcmic: boolean;
  showPaperLess = false;
  btnHeight: number;
  maxContentHeight: number;
  measureHeights: number[] = [];

  constructor(
    private acmicService: AcmicService,
    private customerBannerService: CustomerBannerService,
    private paperlessService: PaperlessService,
    private cdr: ChangeDetectorRef
  ) { }

  public ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.maxContentHeight = (window.innerWidth > 767) ? 145 : 114;
  }

  ngAfterViewInit() {
    this.customerBannerService.getAllCustomerBannersData().subscribe(bannersRes => {
      if (bannersRes && bannersRes.length > 0) {
        this.maxContentHeight = bannersRes[0]?.embeddedImage
          ? Number(bannersRes[0].embeddedImage.height)
          : (window.innerWidth > 767) ? 145 : 114;
        this.banners = bannersRes;
        this.cdr.detectChanges();

        requestAnimationFrame(() => {
          if (this.swiper && this.swiper.nativeElement)
            this.swiper.nativeElement.initialize();
          const bannerWithBtn = this.customerBanners.find(
            banner => banner.btnRef && banner.btnRef.nativeElement?.offsetHeight > 0
          )
          this.btnHeight = bannerWithBtn ? bannerWithBtn.btnRef.nativeElement?.offsetHeight + 24 : 0
          this.calculateMaxContentHeight();
        })
        this.cdr.detectChanges();
      }
      this.paperlessService.$snooze.subscribe((snooze) => {
        this.showPaperLess = (snooze) ? false : !(this.banners && this.banners.length > 0);
        this.cdr.detectChanges();
      });
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.cdr.detectChanges();
    requestAnimationFrame(() => {
      this.calculateMaxContentHeight();
    })
  }

  onContentHeight(bannerContentHeight: number, index: number) {
    this.measureHeights[index] = bannerContentHeight;
    if (this.measureHeights.length === this.customerBanners.length) {
      const maxHeight = Math.max(...this.measureHeights)
      this.applyHeights(maxHeight);
    }
  }

  private calculateMaxContentHeight() {
    this.maxContentHeight = 0;
    this.customerBanners.forEach(banner => {
      const height = banner.titleRef.nativeElement?.offsetHeight + banner.infoRef.nativeElement?.offsetHeight + parseInt(banner.infoRef.nativeElement?.style?.marginTop || '8');
      this.maxContentHeight = Math.max(this.maxContentHeight, height);
    });

    this.applyHeights(this.maxContentHeight);
  }

  private applyHeights(heightToApply: number): void {
    if (heightToApply > 8) {
      this.customerBanners.forEach(banner => {
        banner.appliedContentHeight = heightToApply;
        banner.appliedBannerHeight = heightToApply + this.btnHeight;
      })
    }
  }
}
